import { render, staticRenderFns } from "./PageContact.vue?vue&type=template&id=15416ccc&"
import script from "./PageContact.vue?vue&type=script&lang=js&"
export * from "./PageContact.vue?vue&type=script&lang=js&"
import style0 from "./PageContact.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports